module.exports = "<div class=\"board\">\n  <img src=\"../../assets/images/chess/board.png\" alt=\"\">\n  <div class=\"pieces-container\">\n    <app-pieces *ngFor=\"let piece of pieces; let i = index\" [imgSource]=\"piece\" [id]=\"i\" (idOut)=\"onPieceToggle($event)\"></app-pieces>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/board/board.component.html
// module id = ./src/app/board/board.component.html
// module chunks = 1